import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import qs from 'qs';

export const divisionSiteService = {
  getList,
  getAvailableProperties,
  create,
  batchCreate,
  destroy,
  batchDestroy
};

/**
 * Get all division sites for a division
 */
function getList(divisionId) {
  const queryString = qs.stringify({
    division_id: divisionId
  }, { addQueryPrefix: true });

  return axios
    .get(
      `${apiEndpoint.divisionSites}${queryString}`,
      {
        headers: authHeader(),
      }
    ).then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

/**
 * Get available properties for a division (same corporate group, not yet assigned)
 */
function getAvailableProperties(divisionId) {
  return axios
    .get(
      `${apiEndpoint.divisionSites}/get-available-properties?division_id=${divisionId}`,
      {
        headers: authHeader(),
      }
    ).then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

/**
 * Create a new division site
 */
function create(data) {
  return axios
    .post(
      `${apiEndpoint.divisionSites}/create`,
      data,
      {
        headers: authHeader()
      }
    ).then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    });
}

/**
 * Batch create division sites (assign multiple properties to a division)
 */
function batchCreate(divisionId, propertyIds) {
  return axios
    .post(
      `${apiEndpoint.divisionSites}/batch-create`,
      {
        division_id: divisionId,
        property_ids: propertyIds
      },
      {
        headers: authHeader()
      }
    ).then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    });
}

/**
 * Delete a division site
 */
function destroy(id) {
  return axios
    .delete(
      `${apiEndpoint.divisionSites}/${id}`,
      {
        headers: authHeader()
      }
    ).then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

/**
 * Batch delete division sites
 */
function batchDestroy(ids) {
  return axios
    .post(
      `${apiEndpoint.divisionSites}/batch-delete`,
      { ids },
      {
        headers: authHeader()
      }
    ).then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}
